module.exports = __webpack_public_path__ + "static/img/HeadPortrait.be2154c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/HeadPortrait.jpg
// module id = DXC0
// module chunks = 1